import script from "./BodorNestTubeNav.vue?vue&type=script&setup=true&lang=js"
export * from "./BodorNestTubeNav.vue?vue&type=script&setup=true&lang=js"

import "./BodorNestTubeNav.vue?vue&type=style&index=0&id=47b0bb0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47b0bb0c"]])

export default __exports__